import DeletionWarningModal from "./ConfirmationModal";

export default DeletionWarningModal;